import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import EmojiPicker from "emoji-picker-react";
import { getChatUserList, PostChat } from "../../../redux/chatandnotification/action";
import { useDispatch, useSelector } from "react-redux";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import UploadChatFiles from "../UploadMultipleFilesinChat/UploadChatFiles";
import { Modal } from "reactstrap";
import { titlevalidation } from "../commonvalidation";
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';


const ChatInputBox = ({ selectUser, messagesEndRef }) => {
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [filemodel, setfileModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const chatboxapidata = useSelector(
    ({ chatandnotification: { getposttypechatlist } }) => getposttypechatlist,
  );

  const dispatch = useDispatch();
  const userId = selectUser?.user_id || selectUser?.id;
  const draftKey = `chat_draft_${userId}`;

  const formik = useFormik({
    initialValues: {
      message: "",
      image: null,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      message: titlevalidation,
    }),
    onSubmit: async (values, { resetForm }) => {
      if (values.image && values.image.size > 10 * 1024 * 1024) {
        // 10MB size limit
        alert("File size should be less than 10MB");
        return;
      }

      let imageUrl = "";
      if (values.image) {
        const storage = getStorage();
        const storageRef = ref(
          storage,
          `AllChatReletedFiles/${values.image.name}`,
        );
        const uploadTask = uploadBytesResumable(storageRef, values.image);

        await new Promise((resolve, reject) => {
          uploadTask.on(
            "state_changed",
            null,
            (error) => reject(error),
            async () => {
              imageUrl = await getDownloadURL(uploadTask.snapshot.ref);
              resolve();
            },
          );
        });
      }

      const data = {
        type: "2",
        user_id: selectUser?.user_id || selectUser?.id,
        post_id: "",
        message: values.message,
        image: imageUrl,
      };

      dispatch(PostChat(data, setLoading));
      localStorage.removeItem(draftKey);
      setShowEmojiPicker(false);
      resetForm();
    },
  });

  // Load draft from localStorage
  useEffect(() => {
    if (userId) {
      const savedDraft = localStorage.getItem(draftKey);
      formik.setFieldValue("message", savedDraft || "");
    }
  }, [userId]);

  const handleMessageChange = (e) => {
    formik.handleChange(e);
    const value = e.target.value;
    if (userId) {
      if (value.trim() !== "") {
        localStorage.setItem(draftKey, value);
      } else {
        localStorage.removeItem(draftKey);
      }
    }
  };

  const handleFileChange = (event) => {
    const file = event.currentTarget.files[0];
    formik.setFieldValue("image", file);
  };
  const opentoselectmodel = () => {
    setfileModel(true);
  };
  const handleEmojiSelect = (emojiObject) => {
    const emoji = emojiObject.native || emojiObject.emoji || "";
    const newMessage = formik.values.message + emoji;
    formik.setFieldValue("message", newMessage);
    if (userId) {
      if (newMessage.trim() !== "") {
        localStorage.setItem(draftKey, newMessage);
      } else {
        localStorage.removeItem(draftKey);
      }
    }
  };

  const toggleEmojiPicker = () => {
    setShowEmojiPicker((prevValue) => !prevValue);
  };

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <div className="chatbox-footer">
          <div className="chatbox-footer-first">
            <input
              type="text"
              className="form-control"
              placeholder="Write here"
              rows="1"
              name="message"
              onChange={handleMessageChange}
              onBlur={formik.handleBlur}
              value={formik.values.message}
              onKeyDown={(event) => {
                if (event.key == "Enter" && !event.shiftKey) {
                  event.preventDefault();
                  if (loading) return;
                  formik.handleSubmit();
                }
              }}
            />
            <a onClick={toggleEmojiPicker} className="btn smile">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/smile.svg`}
                alt=""
              />
              {showEmojiPicker ? "" : ""}
            </a>
            <div className="send-btn">
              {/* <input
                                type="file"
                                name="image"
                                onChange={handleFileChange}
                                style={{ display: 'none' }}
                                id="file-upload"
                            /> */}
              <label
                onClick={() => {
                  opentoselectmodel(true);
                }}
                htmlFor="file-upload"
                className="btn"
              >
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/common/attachment.svg`}
                  alt="Attach"
                />
              </label>
              <button type="submit" className="btn" disabled={loading}>
                {loading ? (
                  <span
                    className="spinner-border spinner-border-sm text-primary"
                    role="status"
                    aria-label="Sending"
                  />
                ) : (
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/send.svg`}
                    alt="Send"
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </form>
      {showEmojiPicker &&
        <>
          <Picker
            data={data}
            onEmojiSelect={handleEmojiSelect}
            theme="light"
            previewPosition="none"
            skinTonePosition="none"
          />

          {/* <EmojiPicker onEmojiClick={handleEmojiSelect} /> */}
        </>
      }
      <Modal
        size="xl"
        className="popupmodal rent-modal"
        isOpen={filemodel}
        toggle={() => setfileModel((state) => !state)}
      >
        <UploadChatFiles
          setfileModel={setfileModel}
          id1={selectUser?.user_id}
          id2={selectUser?.id}
          posts={selectUser}
          type={2}
        />
      </Modal>
    </div>
  );
};

export default ChatInputBox;
